var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9ED495",
    d: "M9.818.053a9.463 9.463 0 1 1 0 18.925 9.463 9.463 0 0 1 0-18.925"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.97 5.576 8.615 8.79l-2.015-.876c-1.289-.66-2.459.408-1.708 1.708l2.299 3.438c.629.881 2.134.93 2.846 0l4.637-5.776c.92-1.245-.529-2.598-1.706-1.708"
  })));
};
export default SvgCheck;